import { setListContext } from '../redux/slices/listContextSlice';
import { getEnrichedParts } from '../hooks/useEnrichedTracks';

// Register a tab's visible file list as the player's ambient "local" list
// context, so when a row's track ends playback advances to the NEXT row
// (MusicPlayer's advanceListContext resolves each filePath lazily via
// getAudioUrl) instead of falling through to auto-radio. Auto-radio only
// takes over after the LAST row finishes — same contract as the Library tab,
// which pioneered this pattern (VisualizeLibraryTab.handlePlayClick).
//
// `enrichedOrResolve` is either the useEnrichedTracks map, or a
// `(path) => ({title, artist, cover})` resolver for tabs that hold richer
// per-row identity than the enrichment index (e.g. Metadata's analyzed rows).
export function setLocalListContext(dispatch, orderedPaths, currentPath, enrichedOrResolve) {
    if (!Array.isArray(orderedPaths) || orderedPaths.length === 0) return;
    const resolve = typeof enrichedOrResolve === 'function'
        ? enrichedOrResolve
        : (p) => getEnrichedParts(enrichedOrResolve, p);
    const items = orderedPaths.map((p) => {
        const { title, artist, cover, djpalId } = resolve(p) || {};
        // djpalId = Mixpedia catalog id when the track is known. The radio
        // hand-off at list end seeds catalog-known tracks FIRST — a list tail
        // of album rips otherwise burns every seed attempt on tracks the
        // recommendation API can't match.
        return { filePath: p, title, artist, cover: cover || '', djpalId: djpalId || null };
    });
    const currentIndex = orderedPaths.indexOf(currentPath);
    // Playing a row that's excluded from the play-through list (e.g. a
    // missing-file row) is a solo play — anchoring it at index 0 would make
    // the advance replay the first row.
    if (currentIndex < 0) return;
    dispatch(setListContext({ items, currentIndex, type: 'local' }));
}
